import { HttpClient, HttpEventType, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FileUpload } from '@shared/models/question-types/file-upload';
import { Observable, map } from 'rxjs';
import { ConfigService } from './config.service';

export interface UploadProgress {
  type: 'progress' | 'complete';
  progress?: number;
  response?: any;
}

@Injectable({
  providedIn: 'root',
})
export class FileUploadService {
  private readonly api_url = '';
  private readonly remove_url = '';

  constructor(
    private httpClient: HttpClient,
    private configService: ConfigService,
  ) {
    this.api_url = this.configService.get('FILE_UPLOAD_URL');
    this.remove_url = this.configService.get('FILE_REMOVE_URL');
  }

  mediaUpload(
    file: File | undefined,
    question: FileUpload,
  ): Observable<UploadProgress> {
    if (!file) {
      throw new Error('No file provided');
    }

    const formData = new FormData();
    formData.append('id', `{${question.uploadId}}`);
    formData.append('hash', question.hash);
    formData.append('filename', file.name);
    formData.append('vid', question.id);
    formData.append('fileUploadContent', file, file.name);

    return this.httpClient
      .post(this.api_url, formData, {
        reportProgress: true,
        observe: 'events',
      })
      .pipe(
        map((event) => {
          switch (event.type) {
            case HttpEventType.UploadProgress:
              const progress = event.total
                ? Math.round((100 * event.loaded) / event.total)
                : 0;
              return { type: 'progress' as const, progress };

            case HttpEventType.Response:
              return { type: 'complete' as const, response: event.body };

            default:
              return { type: 'progress' as const, progress: 0 };
          }
        }),
      );
  }

  mediaRemove(question: FileUpload, questId: string, responseId: string) {
    const formData = new FormData();
    formData.append('id', `{${question.uploadId}}`);
    formData.append('hash', question.hash);
    formData.append('qid', questId);
    formData.append('vid', question.id);
    formData.append('rid', responseId);

    const params = new HttpParams();
    const options = {
      params: params,
      reportProgress: true,
    };

    return this.httpClient.post(this.remove_url, formData, options);
  }
}
